export enum ModuleEvents {
    METRIC_CREATED = 'metric-created',
    METRIC_ASSIGNED = 'metric-assigned',
    METRIC_UPDATED = 'metric-updated',
}
